import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { LogoutMenuItem } from '@teetsh/app/src/containers/Header/components/LogoutMenuItem';
import { SwitchUserRoleMenuItem } from '@teetsh/app/src/containers/Header/components/SwitchUserRoleMenuItem';
import { AvatarButton } from '@teetsh/app/src/containers/Header/components/AvatarButton';
import { MenuItems } from '@teetsh/app/src/containers/Header/components/MenuItems';
import React from 'react';
import {
  contactUs,
  documentation,
  reglageMenuItem,
  shareIdeas,
} from '@teetsh/app/src/containers/Director/Layout/Header/menus';
import { Menu } from '@teetsh/app/src/components/Menu';
import 'twin.macro';
import { useUserAccount } from '@teetsh/app/src/queries/user/account/useUserAccount';
import { UserAccount } from '@teetsh/app/src/types/user';

interface Props {
  userAccount?: UserAccount;
  noPremiumButton?: boolean;
  large?: boolean;
}

export function DirectorProfileButton(props: Props) {
  const { isLoading, data } = useUserAccount(!!props.userAccount);
  const userAccount = props.userAccount || data;
  const user = useUser();

  const menuItems = [reglageMenuItem, documentation, contactUs, shareIdeas];

  if (isLoading || !userAccount || !user) {
    return <div tw="h-10 w-48 rounded-lg" className="tsh-skeleton" />;
  }

  return (
    <div tw="flex items-center shrink-0">
      <Menu>
        <AvatarButton userAccount={userAccount} large={props.large} />
        <Menu.Items tw="w-auto min-w-[16rem]">
          <div>
            <MenuItems items={menuItems} />
            <LogoutMenuItem />
          </div>
          <div>
            <SwitchUserRoleMenuItem />
          </div>
        </Menu.Items>
      </Menu>
    </div>
  );
}
